import { styled } from "goober";

export const Form = styled("form")`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  &.edit-info {
    display: flex;
    flex-direction: column;
    gap: var(--sp-4);

    color: var(--shade1);
  }

  .check-mark {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    padding-inline: var(--sp-3);

    color: #30d9d4;

    pointer-events: none;

    transition: var(--transition);
  }

  footer {
    justify-content: flex-end;
  }
`;

export const FormInput = styled("div")`
  label {
    margin-bottom: var(--sp-2);

    color: var(--shade1);
  }

  & > * {
    width: 100%;
  }
`;
